module.exports = __webpack_public_path__ + "redeem-benefit-white.svg?fae81ac86f944367ad0ac141596a7342";